import { Skeleton } from 'antd';
import { useAuth } from 'lib/hooks/auth/use-auth';
import AuthenticatedRegistrationFlow from '../[auth]/AuthenticatedRegistrationFlow';
import UnauthenticatedRegistrationFlow from './UnauthenticatedRegistrationFlow';
import { ClinicOnboardingLayout } from '../layout';

export default function RegistrationFlow() {
  const auth = useAuth();

  if (auth.isUserDataLoading) {
    return <Skeleton active />;
  }

  if (auth.user) {
    return (
      <ClinicOnboardingLayout>
        <AuthenticatedRegistrationFlow />
      </ClinicOnboardingLayout>
    );
  } else {
    return (
      <ClinicOnboardingLayout>
        <UnauthenticatedRegistrationFlow />
      </ClinicOnboardingLayout>
    );
  }
}
